import { render, staticRenderFns } from "./Vulnerabilities.vue?vue&type=template&id=3ae2673f"
import script from "./Vulnerabilities.vue?vue&type=script&lang=js"
export * from "./Vulnerabilities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports